/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-03 18:28:23
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-08 19:00:09
 * @FilePath: /unifyxp-v2-store-portal/src/pages/ProductEditor/Components/EditorHOC/index.tsx
 */

import React from 'react';

import { store } from 'src/store';

import Warning from '@/src/components/Antd/Modal/WarningModal';
import TopLeft from '@/src/layout/EditorPageLayout/GoBackAndBreadCrumb/GoBackAndBreadCrumb';
import TopRight from '@/src/layout/EditorPageLayout/TopRightBtnsGroups/TopRightBtnsGroups';
import { cloneDeep, isEqual } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { Form, Modal } from 'src/components/Antd';
import { ErrorBoundary } from 'src/components/ErrorBoundary';
import { useI18n } from 'src/hooks/useRouterChange';
import DuplicateModal from 'src/pages/ProductEditor/Components/DuplicateModal/DuplicateModal';
import { NEW } from 'src/tools/constant';
import { isUserValid, storeResourceNameGenerator } from 'src/tools/getUserInfo';
import { onFinishFailed, timeoutScroll } from 'src/tools/helper';
import { i18nGet } from 'src/tools/tools';
import { EnumProductType, EnumStatus } from 'src/types/common/product';
import {
  EPermissionSource,
  EnumCategory,
  EnumOperation,
  EnumSubCategory,
} from 'src/types/common/resources';
import { EnumCollapseId, onCollapseChange } from '../slice';
import { switchUuidHooks } from './hooks/customHooks';

const typeName = ['productGiftCardSetting', 'expirationDateSetting', 'type'];
const calendarName = [
  'productGiftCardSetting',
  'expirationDateSetting',
  'expirationDate',
];
const periodName = [
  'productGiftCardSetting',
  'expirationDateSetting',
  'expirationPeriod',
];
const unitName = ['productGiftCardSetting', 'expirationDateSetting', 'unit'];
const redemptionCodeName = ['productGiftCardSetting', 'redemptionCode'];
const taxRulesName = ['taxRules'];
export const allFields = [
  typeName,
  calendarName,
  periodName,
  unitName,
  redemptionCodeName,
];
export { calendarName, periodName, redemptionCodeName, typeName, unitName };

const generateHooksUrl = ({ type }) => {
  if (type === EnumProductType.Simple) {
    return `/product/simpleProduct`;
  }
  if (type === EnumProductType.Set) {
    return `/product/productSet`;
  }
  if (type === EnumProductType.GiftCard) {
    return `/product/virtualProduct`;
  }
  if (type === EnumProductType.Service) {
    return `/product/virtualProduct`;
  }
  return '/';
};

const _getState = () => {
  return store.getState();
};
const _modal = () => {
  return {
    open: false,
    title: '',
    content: '',
    okText: '',
    onOk: null,
    cancelText: '',
    onCancel: null,
  };
};

const EditorHOC = (Component: any, obj) => {
  const {
    getHasModified,
    getName,
    validation,
    getState,
    convertDataFromReduxToServer,
    submit,
    deleteFunction,
    getLoaded,
    getUuid,
    // fetchData,
    resetData,
    duplicate,
    getProductType,
    getLastModified,
    getProduct,
    onProductLoad,
    formName,
    onHasModified,
    getProductIsSold,

    //updateEssentialData,
  } = obj;

  const WrappedComponent = (props) => {
    const i18n = useI18n();
    const getI18n = (str) => i18nGet(i18n, str);
    const disableEdit = !isUserValid({
      source: EPermissionSource.store,
      resourcesGroup: [
        storeResourceNameGenerator({
          category: EnumCategory.Products,
          subCategory: EnumSubCategory.Products,
          operation: EnumOperation.add_edit_product,
        }),
      ],
    });

    const disableDelete = !isUserValid({
      source: EPermissionSource.store,
      resourcesGroup: [
        storeResourceNameGenerator({
          category: EnumCategory.Products,
          subCategory: EnumSubCategory.Products,
          operation: EnumOperation.delete_product,
        }),
      ],
    });
    const [form] = Form.useForm();
    const [showModal, setShowModal] = React.useState<boolean>(false);
    const [modalTitle, setModalTitle] = React.useState<
      string | React.ReactNode
    >('');

    const [modalContent, setModalContent] = React.useState<React.ReactNode>('');
    const [deleteModal, setDeleteModal] = React.useState(_modal());
    const [avaAtt, setAvaAtt] = React.useState([]);
    const handleOnAvaAttOptionsChange = (uuid, option) => {
      const _avaAtt = avaAtt.map((i) => {
        const { uuid: sUid, options } = i;
        if (uuid === sUid) {
          const _o = [...(options || []), option];
          return { ...i, options: _o };
        }
        return i;
      });
      setAvaAtt(_avaAtt);
    };
    const onModalCancel = () => {
      setShowModal(false);
    };
    const _d = useDispatch();
    const _h = useHistory();
    const _p: { uuid: string } = useParams();
    const { uuid } = _p;
    const _isNew = uuid === NEW;
    const type = useSelector(getProductType());
    const hasBeenSold = useSelector(getProductIsSold());
    //const url = generateListUrl({ type: _key, uuid: _p.uuid });

    // React.useEffect(() => {
    //   if (uuid === NEW) {
    //     _d(fetchData(''));
    //   } else {
    //     _d(fetchData(uuid));
    //   }

    //   return () => {
    //     _d(resetData());
    //   };
    // }, []);
    React.useEffect(() => {
      if (_isNew) {
        // fetchProduct('').then((res) => {
        //   _d(onProductLoad(res));
        // });
        getProduct('').then((res) => {
          const { product } = res || {};
          const { availAttributes, attributes, taxRules, taxRulesEnabled } =
            product || {};
          setAvaAtt(availAttributes || []);
          form.setFieldsValue({ attributes, taxRules, taxRulesEnabled });
          _d(onProductLoad(res));
        });
      } else {
        // _d(fetchProduct(uuid));
        getProduct(uuid).then((res: any) => {
          //    console.log('res', res);
          _d(onProductLoad(res));
          const { product } = res;
          const {
            productGiftCardSetting,
            availAttributes,
            attributes,
            taxRules,
            taxRulesEnabled,
          } = product;
          setAvaAtt(availAttributes || []);

          form.setFieldsValue({
            productGiftCardSetting,
            attributes,
            taxRules,
            taxRulesEnabled,
          });
        });
      }

      return () => {
        _d(resetData());
      };
    }, []);

    switchUuidHooks({
      getUuid,
      url: generateHooksUrl({ type: type }),
    });

    const resetCloseModal = () => {
      setDeleteModal(_modal());
    };
    const onDiscard = (state?) => {
      const isEvent = !(state instanceof Event);

      _h.push({
        pathname: '/productsList',
        state: isEvent ? {} : state || {},
      });
    };
    const _delete = () => {
      deleteFunction(uuid).then(() => {
        onDiscard({
          skipNotice: true,
        });
      });
    };
    const onDelete = () => {
      setDeleteModal({
        open: true,
        title: getI18n(
          'allProducts.addvirtualproduct.editorHOC_delete_product_title',
        ),
        content: getI18n(
          'This action cannot be recovered. Do you still want to continue?',
        ),
        okText: getI18n('general.delete'),
        onOk: _delete,
        cancelText: getI18n('general.cancel'),
        onCancel: resetCloseModal,
      });
    };

    const getFormValue = () => {
      const value = form.getFieldsValue();
      return value;
    };

    const handleOnError = (error) => {
      onFinishFailed(formName, error);
      return false;
    };

    const publishFields = avaAtt.map((i) => {
      const { uuid } = i;
      return ['attributes', uuid];
    });

    const _processingDataBeforeSubmitting = (func) => {
      _d(validation());
      const attError = form.getFieldsError(publishFields);
      const errorItem = attError.find((i) => i.errors.length > 0);
      const hasError = !!errorItem;
      if (hasError) {
        // console.log('errorItem', errorItem);
        const { name = [] } = errorItem;
        const pre = formName + '_';
        const suf = name.join('_');
        const id = pre + suf;

        _d(
          onCollapseChange({
            id: EnumCollapseId.Attributes,
            status: true,
          }),
        );
        setTimeout(() => {
          timeoutScroll(id);
        }, 100);
        return;
      }
      const _state: any = getState()(_getState());
      const { dataValid, status } = _state;
      if (status === 'Active') {
        form
          .validateFields(allFields)
          .then(() => {
            const {
              productGiftCardSetting,
              attributes,
              taxRules,
              taxRulesEnabled,
            } = getFormValue() || {};
            if (dataValid) {
              const _data = {
                ...convertDataFromReduxToServer(_state),
                productGiftCardSetting,
                attributes,
                taxRules,
                taxRulesEnabled,
              };
              func(_data);
            }
          })
          .catch((e) => {
            //console.log(e);
            const { errorFields } = e;
            const firstErr = (errorFields || [])[0];
            const { name } = firstErr || {};
            if (isEqual(name, taxRulesName)) {
              _d(
                onCollapseChange({
                  id: EnumCollapseId.Pricing,
                  status: true,
                }),
              );
            } else {
              _d(
                onCollapseChange({
                  id: EnumCollapseId.GiftCardSetting,
                  status: true,
                }),
              );
            }

            handleOnError(e);
          });
      } else {
        const {
          productGiftCardSetting,
          attributes,
          taxRules,
          taxRulesEnabled,
        } = getFormValue() || {};
        if (dataValid) {
          const _data = {
            ...convertDataFromReduxToServer(_state),
            productGiftCardSetting,
            attributes,
            taxRules,
            taxRulesEnabled,
          };

          func(_data);
        }
      }
    };

    const onSubmit = (hideMsg?, func?) => {
      //  console.log(hideMsg);
      //console.log('onSubmit');
      _processingDataBeforeSubmitting((_data) => {
        // console.log('onSubmit', _data);
        // console.log('_data', _data);
        _d(submit({ prod: _data, hideMsg }));
        if (func) func();
      });
    };

    const _onDuplicate = ({ _data, extra }) => {
      //console.log(_data);
      const processData = (prod) => {
        const { attributes } = prod;
        const isUnique = avaAtt.filter((i) => i.unique).map((i) => i.uuid);
        const _attributes = cloneDeep(attributes);
        isUnique.forEach((i) => {
          _attributes[i] = null;
        });

        form.setFieldsValue({
          taxRules: [],
          attributes: _attributes,
        });
        prod.sku = null;

        return prod;
      };
      const p = processData(_data);
      _d(duplicate({ prod: p, extra, hideMsg: true }));
    };

    const onDuplicate = (extra = {}) => {
      // console.log(1);
      onSubmit(true, () => {
        _processingDataBeforeSubmitting((_data) => {
          const { status } = _data;

          const radioList = [
            {
              label: getI18n(
                'allProducts.productEditor.components_EditorHOC_radioList_draft',
              ),
              value: EnumStatus.Draft,
              disable: false,
            },
            {
              label: getI18n(
                'allProducts.productEditor.components_EditorHOC_radioList_active',
              ),
              value: EnumStatus.Active,
              disable: status !== EnumStatus.Active,
            },
          ];
          setModalContent(
            <DuplicateModal
              setModal={setShowModal}
              onSubmit={(obj) => {
                _onDuplicate({ _data, extra: obj });
              }}
              radioList={radioList}
              status={status}
            />,
          );
          setShowModal(true);
          setModalTitle(
            getI18n(
              'allProducts.addvirtualproduct.editorHOC_radioList_duplicate_product',
            ),
          );
        });
      });
    };
    const hasModified = useSelector(getHasModified());

    const _loaded: any = useSelector(getLoaded());
    const { loaded } = _loaded || {};

    const topRight = (
      <TopRight
        {...(_isNew
          ? {}
          : {
              onCopy: disableEdit ? null : onDuplicate,
              onDelete: disableDelete ? null : onDelete,
              displayDuplicateGroup: true,
            })}
        onDiscard={onDiscard}
        onSubmit={onSubmit}
        onSaveDisable={disableEdit || !hasModified}
      />
    );

    const _props = {
      avaAtt,
      handleOnAvaAttOptionsChange,
      type,
      hasBeenSold,
      history: _h,
      params: _p,
      dispatch: _d,
      hasModified,
      onDiscard,
      selector: useSelector,
      setShowModal,
      setModalTitle,
      setModalContent,
      topLeft: (
        <_TopLeft
          getName={getName}
          isNew={_isNew}
          onDiscard={onDiscard}
          loaded={loaded}
          getLastModified={getLastModified}
        />
      ),
      topRight,
      loaded,
      form,
    };

    return (
      <ErrorBoundary>
        {deleteModal.open && (
          <Warning
            visible
            header={deleteModal.title}
            onOk={deleteModal.onOk}
            okText={deleteModal.okText}
            cancelText={deleteModal.cancelText}
            onCancel={deleteModal.onCancel}>
            {deleteModal.content}
          </Warning>
        )}
        <Modal
          width={600}
          visible={showModal}
          title={modalTitle}
          onCancel={onModalCancel}
          cancelText={getI18n('general.cancel')}>
          {modalContent}
        </Modal>
        <Form
          form={form}
          name={formName}
          onValuesChange={() => {
            _d(onHasModified());
          }}>
          <Component {...props} {..._props} />
        </Form>
      </ErrorBoundary>
    );
  };
  return WrappedComponent;
};
export default EditorHOC;
const _TopLeft = ({ getName, isNew, onDiscard, loaded, getLastModified }) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const _isNew = isNew;
  const lastModified = useSelector(getLastModified());
  const name: string = useSelector(getName());

  const displayName = React.useMemo(() => {
    return name;
  }, [lastModified, loaded]);
  const breadcrumbData = [
    {
      url: '/',
      name: getI18n('general.sider.home'),
    },
    {
      url: '/productsList',
      name: getI18n('general.allProducts'),
    },
    {
      url: '',
      name: _isNew
        ? getI18n('allProducts.productEditor.components_EditorHOC_addnewpage')
        : displayName,
    },
  ];

  return <TopLeft goBack={onDiscard} breadcrumbData={breadcrumbData} />;
};
